
export const shippingDefaultDimenstions = {
  length: '8.5',
  width: '11',
  height: '1',
};
